$(document).ready(function() {
    var $header = $('.header.header--right-off-canvas');
    var $mainContent = $('.MainContent');
    
    if ($header.length > 0) {
      $mainContent.addClass('MainContent-header--right-off-canvas-main');
    }
});

$(document).ready(function() {

  $(window).scroll(function() {
	var scroll = $(window).scrollTop();
	    if (scroll >= 200) {
		   $('.header-wrapper-right-off-canvas').addClass('sticky-header-visible');
	    }
        else {
        $('.header-wrapper-right-off-canvas').removeClass('sticky-header-visible');
          
	    }
	});
});








                  